// export const baseURL = "http://localhost:5000/api/";
export const baseURL = "https://setmindapi.brainexworld.com/api/";

export const SocketURL = 'https://setmindapi.brainexworld.com/';

// export const imageURL = "http://localhost:5000/";
export const imageURL = "https://setmindapi.brainexworld.com";